// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../node_modules/font-awesome/css/font-awesome.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Adjust height and overflow for html, body, and content area */
html,
body {
    height: 100%;
    margin: 0;
}

.page-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.scanners-page-content {
    flex: 1 1;
    /* Allow the content to grow and take available space */
    padding: 20px;
    overflow-y: auto;
    /* Enable vertical scrolling if needed */
    height: 100%;
    /* Set height to 100% */
    padding: 20px;
    box-sizing: border-box;
}

.scanners-page {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    height: max-content;
}

.standard-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px;
}

.standard-row>* {
    padding: 20px;
}

.scanner-generate-key-tile {
    width: 90%;
    padding: 10px;
    border: 2px solid #20295b;
    border-radius: 10px;
    margin: 10px;
}

.scanner-key-tile {
    width: 90%;
    padding: 10px;
    border: 2px solid #20295b;
    border-radius: 10px;
    margin: 10px;
    overflow-x: scroll;
}

.scanner-key {
    width: min-content;
    overflow-x: auto;
}
.key-cell {
    width: 70%;
    max-width: 20px;
    overflow-x: scroll;
  }

.mobile-scanner {
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    min-height: 10vh;
    background-color: #334191;
    color: #fff;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content: space-around;
    font-size: 11px;
}

table.scanner-table {
    height: 100%;
    width: 100%;
    max-width: 70vw;
    max-height: -moz-fit-content;
    max-height: fit-content;
    align-items:center;
    justify-content: space-around;
  }
  table.scanner-table th,
  table.scanner-table td{
    overflow-wrap: break-word;
    word-wrap: break-word;
  }    
  table.scanner-table td:first-child {
    width: 35%;
    word-wrap: break-word;
  }
  table.scanner-table td:nth-child(2) {
    word-wrap: break-word;
    word-break: break-all;    
  }`, "",{"version":3,"sources":["webpack://./src/css/pages/ProductionScanners.css"],"names":[],"mappings":"AAEA,gEAAgE;AAChE;;IAEI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,uDAAuD;IACvD,aAAa;IACb,gBAAgB;IAChB,wCAAwC;IACxC,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;EACpB;;AAEF;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,4BAAuB;IAAvB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;;IAEE,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,qBAAqB;EACvB","sourcesContent":["@import \"~font-awesome/css/font-awesome.min.css\";\r\n\r\n/* Adjust height and overflow for html, body, and content area */\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.page-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n.scanners-page-content {\r\n    flex: 1;\r\n    /* Allow the content to grow and take available space */\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    /* Enable vertical scrolling if needed */\r\n    height: 100%;\r\n    /* Set height to 100% */\r\n    padding: 20px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.scanners-page {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: max-content;\r\n}\r\n\r\n.standard-row {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 10px;\r\n}\r\n\r\n.standard-row>* {\r\n    padding: 20px;\r\n}\r\n\r\n.scanner-generate-key-tile {\r\n    width: 90%;\r\n    padding: 10px;\r\n    border: 2px solid #20295b;\r\n    border-radius: 10px;\r\n    margin: 10px;\r\n}\r\n\r\n.scanner-key-tile {\r\n    width: 90%;\r\n    padding: 10px;\r\n    border: 2px solid #20295b;\r\n    border-radius: 10px;\r\n    margin: 10px;\r\n    overflow-x: scroll;\r\n}\r\n\r\n.scanner-key {\r\n    width: min-content;\r\n    overflow-x: auto;\r\n}\r\n.key-cell {\r\n    width: 70%;\r\n    max-width: 20px;\r\n    overflow-x: scroll;\r\n  }\r\n\r\n.mobile-scanner {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    min-height: 10vh;\r\n    background-color: #334191;\r\n    color: #fff;\r\n    display: flex;\r\n    flex-direction:row;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n    font-size: 11px;\r\n}\r\n\r\ntable.scanner-table {\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 70vw;\r\n    max-height: fit-content;\r\n    align-items:center;\r\n    justify-content: space-around;\r\n  }\r\n  table.scanner-table th,\r\n  table.scanner-table td{\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n  }    \r\n  table.scanner-table td:first-child {\r\n    width: 35%;\r\n    word-wrap: break-word;\r\n  }\r\n  table.scanner-table td:nth-child(2) {\r\n    word-wrap: break-word;\r\n    word-break: break-all;    \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
